import React from "react";
import Navbar from "../Navbar/Navbar";
import Bredcom from "../Bredcom/Bredcom";
import Footer from "../Footer/Footer";
import { Link } from "react-router-dom";

function EngleskiJezik1M() {
  return (
    <>
      <Navbar />
      <Bredcom title="Početna" subtitle="Engleski jezik I" />
      <div className="container mt-4 pt-40">
        <div className="row">
          <div className="col-md-8">
            <div className="content-container">
              <h2 className="section-title">Engleski jezik I</h2>
              <p>
                <strong>Studijski program:</strong> Menadžment
              </p>
              <p>
                <strong>Naziv predmeta:</strong> Engleski jezik I
              </p>
              <p>
                <strong>Nastavnik:</strong>{" "}
              </p>
              <p>
                <strong>Status predmeta:</strong> Obavezan
              </p>
              <p>
                <strong>Broj ECTS:</strong> 7
              </p>
              <p>
                <strong>Uslov:</strong> Nema
              </p>
              <h3>Cilj predmeta</h3>
              <p>
                Ovladavanje osnovnim elementima strukture stranog jezika i
                razvijanje osnovnih komunikativnih sposobnosti neophodnih za
                uspješno snalaženje u raznovrsnim životnim i poslovnim
                situacijama. Uz aktiviranje motivacije tržište nastave u prvoj
                godini je na automatizaciji akustičko-motornih obrazaca jezičke
                građe i istovremenom razvijanju sve četiri jezičke vještine
                (čitanja razumijevanja pisanja i govora). U cilju lakšeg
                sticanja bazičnog nivoa komunikativne kompetencije nastava je u
                velikoj mjeri bazirana na rekogniciji. Nastava je koncipirana
                tako da poslije dva semestra u znatnoj mjeri doprinosi
                nivelaciji znanja apsolutnih početnika i studenata koji već
                posjeduju određena predznanja.
              </p>
              <h3>Ishod predmeta</h3>
              <p>
                Nakon što sa uspjehom savladaju studijski program studenti će
                moći da vode jednostavniji razgovor iz domena svakodnevnog
                života iz svoje stručne oblasti i da argumentovano izlože
                mišljenje i stav o određenoj temi. Takođe će moći da izlože
                kraću unaprijed pripremljenu poslovnu prezentaciju uz iznošenje
                informacija vezanih za djelatnost kompanije njenu organizacionu
                strukturu vodeće proizvode ili usluge tekuće aktivnosti i
                planove za budućnost.Na planu čitanja i razumijevanja pročitanog
                student će moći da razumije sadržaj standardne poslovne
                korespondencije (upita porudžbine potvrde) brošura reklamnih
                materijala itd.
              </p>
              <h3>Sadržaj predmeta</h3>
              <p>
                Predstavljanje i upoznavanje prilikom prvog kontakta.
                Predstavljanje firme njene djelatnosti organizacione strukture
                zaposlenih zanimanja i funkcija u preduzeću uspostavljanje
                telefonskog kontakta. Zakazivanje sastanaka i drugi oblici
                dogovaranja. Poslovna putovaja (aerodrom rezervacije carina
                mjenjačnica i sl.). Poslovni izlasci. Poslovni sastanci. Osnove
                poslovne korespodencije: elementi poslovnog pisma poruke. Osnove
                korespodencije posredstvom kompjutera (Word E-mail Internet).
                Kultura komuniciranja i međukulturna komunikacija (kulturne
                razlike). Leksički nivo: Nastavni program predviđa usvajanje
                najfrekventnije opšte leksike i uobičajenih kolokacija kao i
                izvjesnog broja osnovnih stručnih termina iz domena poslovne
                ekonomije i računarstva. Gramatički nivo: Osnove morfologije i
                sintakse stranog jezika (član imenice zamjenice pridjevi prilozi
                brojevi glagolska vremena aktiv i pasiv modalni glagoli
                rečenične konstrukcije karakteristične za dati strani jezik.
              </p>

              <h3>Metode izvođenja nastave</h3>
              <p>
                Nastava je u skladu sa zahtjevima predmeta interaktivna. Težište
                je na razvijanju receptivne i automatizaciji reproduktivne
                sposobnosti uz pomoć različitih tipova vježbi i simulacije
                tipičnih poslovnih situacija i razgovora.
              </p>

              <h3 className="pt-20 pb-10">Plan rada</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Nedjelja</th>
                    <th>Fond časova</th>
                    <th>Sadržaj</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Pripremna</td>
                    <td>Upoznavanje, dogovor o radu i slično</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>I</td>
                    <td>2P + 2V</td>
                    <td>
                      Predstavljanje i upoznavanje prilikom prvog kontakta
                    </td>
                  </tr>
                  <tr>
                    <td>II</td>
                    <td>2P + 2V</td>
                    <td>
                      Predstavljanje firme njene djelatnosti organizacione
                      strukture zaposlenih
                    </td>
                  </tr>
                  <tr>
                    <td>III</td>
                    <td>2P + 2V</td>
                    <td>
                      Zanimanja i funkcija u preduzeću uspostavljanje
                      telefonskog kontakta
                    </td>
                  </tr>
                  <tr>
                    <td>IV</td>
                    <td>2P + 2V</td>
                    <td>Zakazivanje sastanaka i drugi oblici dogovaranja</td>
                  </tr>
                  <tr>
                    <td>V</td>
                    <td>2P + 2V</td>
                    <td>
                      Gramatički nivo: Osnove morfologije i sintakse stranog
                      jezika (član imenice zamjenice)
                    </td>
                  </tr>
                  <tr>
                    <td>VI</td>
                    <td></td>
                    <td>Kolokvijum I</td>
                  </tr>
                  <tr>
                    <td>VII</td>
                    <td>2P + 2V</td>
                    <td>
                      Poslovna putovaja (aerodrom rezervacije carina menjačnica
                      i sl.)
                    </td>
                  </tr>
                  <tr>
                    <td>VIII</td>
                    <td>2P + 2V</td>
                    <td>Gramatički nivo: prilozi brojevi</td>
                  </tr>
                  <tr>
                    <td>IX</td>
                    <td>2P + 2V</td>
                    <td>
                      Osnove korespodencije posredstvom kompjutera (Word E-mail
                      Internet)
                    </td>
                  </tr>
                  <tr>
                    <td>X</td>
                    <td>2P + 2V</td>
                    <td>Poslovni izlasci. Poslovni sastanci</td>
                  </tr>
                  <tr>
                    <td>XI</td>
                    <td>2P + 2V</td>
                    <td>
                      Gramatički nivo: glagolska vremena aktiv i pasiv modalni
                      glagoli
                    </td>
                  </tr>
                  <tr>
                    <td>XII</td>
                    <td></td>
                    <td>Kolokvijum II</td>
                  </tr>
                  <tr>
                    <td>XIII</td>
                    <td>2P + 2V</td>
                    <td>
                      Osnove poslovne korespodencije: elementi poslovnog pisma
                      poruke
                    </td>
                  </tr>
                  <tr>
                    <td>XIV</td>
                    <td>2P + 2V</td>
                    <td>
                      Gramatički nivo: rečenične konstrukcije karakteristične za
                      dati strani jezik
                    </td>
                  </tr>
                  <tr>
                    <td>XV</td>
                    <td>2P + 2V</td>
                    <td>
                      Kultura komuniciranja i međukulturna komunikacija
                      (kulturne razlike)
                    </td>
                  </tr>
                  <tr>
                    <td>XVI</td>
                    <td></td>
                    <td>Sveobuhvatni ispit</td>
                  </tr>
                  <tr>
                    <td>XVII</td>
                    <td></td>
                    <td>Ovjera semestra i upis ocjena</td>
                  </tr>
                  <tr>
                    <td>XVIII</td>
                    <td></td>
                    <td>Popravni ispitni rok</td>
                  </tr>
                </tbody>
              </table>

              <h3 className="pt-20 pb-10">Obaveze studenata</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Obaveze studenata</th>
                    <th>U toku nastave</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Obaveze studenata u toku nastave</td>
                    <td>
                      Studenti su obavezni da pohađaju nastavu, vježbe i ispite
                    </td>
                  </tr>
                  <tr>
                    <td>Konsultacije</td>
                    <td>
                      Konsultacije se održavaju sa nastavnikom i saradnikom
                      poslije časova
                    </td>
                  </tr>
                  <tr>
                    <td>Opterećenje studenata u časovima</td>
                    <td>
                      <table className="table table-bordered ofpep-section">
                        <thead>
                          <tr>
                            <th>Nedjeljno</th>
                            <th>U semestru</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Ukupno: 4 č / 300 h</td>
                            <td>Ukupno: 60 č</td>
                          </tr>
                          <tr>
                            <td>Predavanja: 2 č / 130 h</td>
                            <td>Nastava + završni ispit: 52 č</td>
                          </tr>
                          <tr>
                            <td>Vježbe: 2 č / 130 h</td>
                            <td>Priprema i ovjera semestra: 3 č</td>
                          </tr>
                          <tr>
                            <td>Individualni rad:</td>
                            <td>Priprema i polaganje popravnog ispita: 15 č</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>

              <h3 className="pt-20 pb-10">Ocjenjivanje</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Ocjena</th>
                    <th>Broj poena</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>A(odličan)</td>
                    <td>91-100</td>
                  </tr>
                  <tr>
                    <td>B(vrlo dobar)</td>
                    <td>81-90</td>
                  </tr>
                  <tr>
                    <td>C(dobar)</td>
                    <td>71-80</td>
                  </tr>
                  <tr>
                    <td>D(zadovoljava)</td>
                    <td>61-70</td>
                  </tr>
                  <tr>
                    <td>E(dovoljan)</td>
                    <td>51-60</td>
                  </tr>
                  <tr>
                    <td>F(nedovoljan)</td>
                    <td>0-50</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="col-md-4 pt-10">
            <aside className="sidebar-widget">
              <section
                id="custom_html-5"
                className="widget_text widget widget_custom_html"
              >
                <h2 className="widget-title">Zapratite nas</h2>
                <div className="textwidget custom-html-widget">
                  <div className="widget-social">
                    <a
                      href="https://www.facebook.com/fpebar.me"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-facebook-f" />
                    </a>
                    <a
                      href="https://www.instagram.com/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-instagram" />
                    </a>
                    <a
                      href="https://www.youtube.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-youtube" />
                    </a>
                    <a
                      href="https://www.tiktok.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on Tiktok"
                      title="Tiktok"
                    >
                      <i className="fab fa-tiktok" />
                    </a>
                    <a
                      href="https://www.linkedin.com/school/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on LinkedIn"
                      title="LinkedIn"
                    >
                      <i className="fab fa-linkedin-in" />
                    </a>
                  </div>
                </div>
              </section>
              <section id="categories-1" className="widget widget_categories">
                <h2 className="widget-title">Korisni linkovi</h2>
                <ul>
                  <li className="cat-item cat-item-16">
                    <Link to="/o-fpep">O Fakultetu</Link>
                  </li>
                  <li className="cat-item cat-item-23">
                    <Link to="/akreditacija-fpep">Akreditacija FPEP-a</Link>
                  </li>
                  <li className="cat-item cat-item-18">
                    <Link to="/upis">Upis</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/cijene-studija">Školarina</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/erasmus">Erasmus+</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/projekti">Projekti</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/dom-studenata">Dom studenata</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/galerija">Galerija</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/novosti">Novosti</Link>
                  </li>
                </ul>
              </section>
              <section
                id="recent-posts-4"
                className="widget widget_recent_entries"
              >
                <h2 className="widget-title">Studijski programi</h2>
                <ul>
                  <li>
                    <span className="post-date">
                      <strong>Osnovne studije</strong> <br />
                    </span>
                    <Link to="/racunovodstvo-finansije-i-bankarstvo">
                      Računovodstvo, bankarstvo i finansije
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/menadzment">
                      Menadžment
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-osnovne">
                      Pravo
                      <br />
                    </Link>
                  </li>
                  <li>
                    <span className="post-date">
                      <strong>Master studije</strong> <br />
                    </span>
                    <Link to="/poslovna-ekonomija">
                      Poslovna ekonomija
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/ekonomija-javnog-sektora">
                      Ekonomija javnog sektora
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-master">
                      Pravo
                      <br />
                    </Link>
                  </li>
                </ul>
              </section>
            </aside>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default EngleskiJezik1M;
